import useIsMobile from 'utils/hooks/useIsMobile'
import { useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../helpers'

const SCROLL_THRESHOLD = 200
const CONTAINER_IDS = ['kt_wrapper', 'kt_content', 'kt_post']

export function ScrollTop() {
  const [visible, setVisible] = useState(false)
  const [hovered, setHovered] = useState(false)
  const isMobile = useIsMobile()
  const scrollContainerRef = useRef<Element | null>(null)

  useEffect(() => {
    const onScroll = (e: Event) => {
      const target = e.currentTarget as Element | Window
      let scrollPos: number

      if (target instanceof Window) {
        scrollPos = window.scrollY || document.documentElement.scrollTop
        scrollContainerRef.current = document.documentElement
      } else {
        scrollPos = (target as Element).scrollTop
        scrollContainerRef.current = target as Element
      }

      setVisible(scrollPos > SCROLL_THRESHOLD)
    }

    window.addEventListener('scroll', onScroll)

    const containers = CONTAINER_IDS
      .map(id => document.getElementById(id))
      .filter((el): el is HTMLElement => el !== null)
    containers.forEach(el => el.addEventListener('scroll', onScroll))

    return () => {
      window.removeEventListener('scroll', onScroll)
      containers.forEach(el => el.removeEventListener('scroll', onScroll))
    }
  }, [])

  const handleClick = () => {
    const container = scrollContainerRef.current ?? document.documentElement
    container.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (!visible) return null

  return (
    <div
      id='kt_scrolltop'
      className={isMobile ? 'scrolltop h-35px w-35px' : 'scrolltop h-65px w-65px'}
      style={{ display: 'flex', opacity: hovered ? 1 : 0.3 }}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <KTSVG
        path='/media/icons/duotune/arrows/arr066.svg'
        svgClassName={isMobile ? 'h-20px w-20px' : 'h-40px w-40px'}
      />
    </div>
  )
}
